// extracted by mini-css-extract-plugin
export default {"error":"error_error__+RLRK","warning":"error_warning__s8TTX"};